import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import { Collections, type PatientsResponse } from "@/types/pocketbase.ts";
import type { FullListOptions, ListOptions, OneOptions } from "@/types/query-options";

const COLLECTION = Collections.Patients;

export const patientsQueries = {
	all: () => [COLLECTION],
	lists: () => [...patientsQueries.all(), "list"],
	list: <Texpand = unknown>(params: ListOptions = { page: 1, perPage: 10, options: {} }) =>
		queryOptions({
			queryKey: [...patientsQueries.lists(), { page: params.page, perPage: params.perPage, options: params.options }],
			queryFn: () =>
				pb.collection(COLLECTION).getList<PatientsResponse<Texpand>>(params.page, params.perPage, params.options),
			placeholderData: keepPreviousData,
		}),
	fullLists: () => [...patientsQueries.lists(), "fullList"],
	fullList: <Texpand = unknown>(options?: FullListOptions) =>
		queryOptions({
			queryKey: [...patientsQueries.fullLists(), options ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getFullList<PatientsResponse<Texpand>>({
					...options?.options,
					sort: options?.options?.sort ?? "-created",
				}),
			placeholderData: keepPreviousData,
		}),
	ones: () => [...patientsQueries.all(), "one"],
	one: <Texpand = unknown>(params?: OneOptions) =>
		queryOptions({
			queryKey: [...patientsQueries.ones(), params?.id, params?.options ?? {}],
			queryFn: () => pb.collection(COLLECTION).getOne<PatientsResponse<Texpand>>(params?.id ?? "", params?.options),
			enabled: Boolean(params?.id),
		}),
};
